import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { useQuery } from "../CustomHooks/useQuery";
import { mapLoginStateToProps } from "../../services/mapStateToProps";
import {
  login_request,
  checkTokenValid,
  checkLoginFailure,
} from "../../constants/default_request";
import {
  vtrTripApiRequest,
  login,
  logout,
} from "../../actions/middleware_actions";
import RefreshToken from "../common/RefreshToken";
import Spinner from "../common/Spinner";

function OAuthLogin({ userLogin, userLogout, editTrip, error, ...props }) {
  const [tripId, setTripId] = useState(0);
  const [localError, setLocalError] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);

  let query = useQuery();
  let auth = useSelector((state) => state.auth);
  const isTokenValid = checkTokenValid(auth);
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const username = userInfo ? userInfo.username : "";
  const didLoginFail = checkLoginFailure(error);
  let editRedirect = useSelector((state) => state.vtrTrip.editRedirect);
  const invalidVtr = useSelector((state) => state.error.error[0]);

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleLogout = () => {
    setOpenDialog(false);
    userLogout();
  };

  useEffect(() => {
    if (
      invalidVtr &&
      "VTR_DOCID" in invalidVtr &&
      invalidVtr.VTR_DOCID === false
    ) {
      setShowSpinner(false);
    } else if (
      invalidVtr &&
      "status" in invalidVtr &&
      invalidVtr.status === "ERROR"
    ) {
      setShowSpinner(false);
    }
  }, [invalidVtr]);

  useEffect(() => {
    didLoginFail ? setOpenDialog(true) : setOpenDialog(false);
  }, [didLoginFail]);

  useEffect(() => {
    if (!query.get("vtr_trip_id")) {
      setLocalError(true);
      toast.error("Request failed! Missing parameters");
      return;
    }

    if (query.get("vtr_trip_id")) setTripId(query.get("vtr_trip_id"));

    if (!isTokenValid) {
      setOpenDialog(true);
      setShowSpinner(false);
      return;
    }

    if (
      auth.client_id !== undefined &&
      auth.token !== undefined &&
      tripId !== 0
    ) {
      setShowSpinner(true);
      editTrip(auth.client_id, auth.token, auth.user_app_status, tripId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripId, isTokenValid]);

  if (localError) {
    setShowSpinner(false);
    return null;
  }

  return (
    <>
      {openDialog && (
        <RefreshToken
          user={username}
          loginRequest={login_request}
          loginUser={userLogin}
          logoutUser={handleLogout}
          toggleDialog={handleClose}
          disableUsername={false}
        />
      )}
      {showSpinner && <Spinner />}
      {editRedirect && (
        <Navigate
          to={`${process.env.PUBLIC_URL}/vtr-trip-review`}
          state={{
            trip_id: tripId,
            client_id: auth.clientId,
            redirect: false,
            isAuthUser: true,
          }}
        />
      )}
    </>
  );
}

const mapDispatchToProps = {
  editTrip: vtrTripApiRequest,
  userLogin: login,
  userLogout: logout,
};

export default connect(mapLoginStateToProps, mapDispatchToProps)(OAuthLogin);
